import React, { ChangeEvent, useState } from 'react'

import { Icon } from '../../../components/Icon'
import { Accordion, AccordionItem } from '../../candidates/components/Accordion'
import Modal from '../../../components/UI/UIModal'
import UIButton from '../../../components/UI/UIButton'
import UITabBar from '../../../components/UI/UITabBar'
import UISwitch from '../../../components/UI/UISwitch'
import UITextInput from '../../../components/UI/UITextInput'
import UIPasswordInput from '../../../components/UI/UIPasswordInput'
import { useAuth } from '../../../context/AuthContext'
import { addNewPassword } from '../../../api/settings.tsx/settings'
import { incidentData } from '../../../utils/types'
import { toast } from 'react-toastify'

export interface password {
  oldPassword: string
  newPassword: string
}

const initialData = {
  oldPassword: '',
  newPassword: '',
}

const Account = () => {
  const [switchValue, setSwitchValue] = useState<boolean>(false)
  const [passwordData, setPasswordData] = useState(initialData)
  const createNewPassword = async (): Promise<void> => {
    try {
      const response = (await addNewPassword(passwordData)) as {
        status?: string
        data: incidentData
      }
      if (response?.status == 'successful') {
        toast.success('Passsowrd Updated.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  const handleChange = (fieldName: string, value: string): void => {
    setPasswordData((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }))
  }

  const handleSwitchChange = (value: boolean) => {
    setSwitchValue(value)
  }

  return (
    <>
      <div className="flex my-8 gap-2">
        {/* First column */}
        <div className="flex flex-col w-8/12 gap-4">
          <div className="w-full p-4 bg-gray3 rounded-xl flex gap-2">
            <div className="mt-1">
              <Icon
                name={'IconInfoCircle'}
                width={16}
                height={16}
                stroke="#02698C"
                strokeWidth={1.2}
              />
            </div>
            <div className="flex-1">
              <p className="text-sm font-semibold leading-6 text-text2">
                Your Profile
              </p>
              <p className="text-sm font-normal leading-6 text-bluishGreen">
                Your Account email and information is managed in your SCR Record
              </p>
            </div>
          </div>
          <Accordion defaultActiveIndex={0}>
            <AccordionItem
              onClick={() => console.log('Accordion')}
              title={'Reminder Emails'}
              isActive={false}
            >
              <div className="flex flex-col gap-4 mt-2 my-4 px-1">
                <div className="w-full p-4 bg-gray1 rounded-xl flex">
                  <div className="flex-1">
                    <p className="text-sm font-semibold leading-6 text-text4">
                      Reminder Email Enabled
                    </p>
                    <p className="text-sm font-normal leading-6 text-text3">
                      Sends email reminders when certain records are near expiry
                      date.
                    </p>
                  </div>
                  <div>
                    <UISwitch
                      value={switchValue}
                      onValueChange={handleSwitchChange}
                    />
                  </div>
                </div>
                <div className="w-full p-4 bg-gray1 rounded-xl flex">
                  <div className="flex-1">
                    <p className="text-sm font-semibold leading-6 text-text4">
                      Whistleblowing Reply Emails enabled
                    </p>
                    <p className="text-sm font-normal leading-6 text-text3">
                      Recieve email notifications when recieving replies to
                      whistleblowing reports.
                    </p>
                  </div>
                  <div>
                    <UISwitch
                      value={switchValue}
                      onValueChange={handleSwitchChange}
                    />
                  </div>
                </div>
              </div>
            </AccordionItem>
          </Accordion>
          <Accordion defaultActiveIndex={0}>
            <AccordionItem
              onClick={() => console.log('Accordion')}
              title={'Password Reset'}
              isActive={false}
            >
              <div className="flex flex-col gap-4 mt-2 my-4 px-1">
                <div className="flex flex-col w-full gap-5">
                  <UIPasswordInput
                    onChange={(e) => {
                      handleChange('oldPassword', e.target.value)
                    }}
                    value={passwordData.oldPassword}
                    placeholder="Your old password"
                    label={'Old Password'}
                    iconName={'IconLock'}
                  />
                  <UIPasswordInput
                    onChange={(e) => {
                      handleChange('newPassword', e.target.value)
                    }}
                    value={passwordData.newPassword}
                    placeholder="Your new password"
                    label={'New Password'}
                    iconName={'IconLock'}
                    labelBottomList={[
                      `Length: Make your password at least 8 - 12 characters long.`,
                      `Mix It Up: Use a combination of uppercase and lowercase letters, numbers, and special characters.`,
                      `Avoid Common Patterns: Stay away from easy-to-guess sequences like "123456" or "password"`,
                      `No Personal Info: Don't use personal information like names or birthdays in your password. Keep your password strong and secure to protect your personal data!`,
                    ]}
                  />
                  <div className="w-[30%]">
                    <UIButton
                      label="Change"
                      type="button"
                      onClick={() => createNewPassword()}
                      disabled={passwordData.newPassword == ''}
                    />
                  </div>
                </div>
              </div>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
      <div className="bg-gray3 w-full h-[1px] "></div>
      <div className="w-[33%] mt-6 gap-[20px] flex">
        <UIButton label="Update" />
      </div>
    </>
  )
}

const SuperSetting = () => {
  const [isAddSchoolModalOpen, setIsAddSchoolModalOpen] =
    useState<boolean>(false)
  const { logout } = useAuth()
  const [activeTab, setActiveTab] = useState<string>('Account')
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const [previewUrl, setPreviewUrl] = useState<string>('')

  console.log('selectedFile', selectedFile)

  const handleFileUpload = (event: ChangeEvent<HTMLInputElement>) => {
    console.log('test')
    const file = event.target.files?.[0]
    if (file) {
      setSelectedFile(file)
      setPreviewUrl(URL.createObjectURL(file))
    }
    // Reset the input field to allow selecting the same file again
    event.target.value = ''
  }

  const handlePressTab = (tab: string) => {
    setActiveTab(tab)
  }

  return (
    <div
      className={
        'flex flex-col gap-20 w-full bg-white  h-full rounded-3xl p-5 '
      }
    >
      <div
        style={{
          height: 'calc(100vh - 100px)',
          overflow: 'auto',
          scrollbarWidth: 'none',
        }}
      >
        <div className={'flex w-full justify-between items-start '}>
          <div className="flex-col w-[50%] gap-[20px]">
            <p className={'text-lg leading-6 text-text2 font-bold'}>Settings</p>
          </div>
          <div>
            <div
              onClick={() => logout()}
              className="gap-[10px]  bg-gray2 items-center justify-between min-w-[95px] text-white h-12 px-[20px] flex rounded-[72px] cursor-pointer"
            >
              <p className={'font-semibold text-sm text-text1 leading-6'}>
                Logout
              </p>
              <Icon
                name={'IconLogout'}
                strokeWidth={1}
                stroke={'#3487A2'}
                width={16}
                height={16}
              />
            </div>
          </div>
        </div>
        <UITabBar
          titles={[
            'Account',
            'Notifications',
          ]}
          activeTab={activeTab}
          onPressTab={handlePressTab}
          containerStyle="mt-4"
          activeTabText="text-text2"
        />
        {activeTab == 'Account' && <Account />}

        {activeTab == 'Notifications' && <></>}
      </div>
      <Modal
        customStyle={{
          borderRadius: 16,
          width: '480px',
          padding: '24px 16px',
        }}
        isOpen={isAddSchoolModalOpen}
        onClose={() => setIsAddSchoolModalOpen(!isAddSchoolModalOpen)}
      >
        <div
          className={
            'max-h-[80vh] overflow-scroll custom-scrollbar items-center px-4 py-2  flex flex-col gap-4'
          }
        >
          <div
            onClick={() => setIsAddSchoolModalOpen(!isAddSchoolModalOpen)}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconBuilding'}
              stroke="#02698C"
              height={52}
              width={52}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <p className={'text-text2 text-lg font-bold leading-6'}>
              Add School
            </p>
            <p className={'text-sm text-text1 font-normal leading-6'}>
              Please enter the details for school
            </p>
          </div>
          {previewUrl ? (
            <div className="flex w-full items-center gap-4 mt-2">
              <img
                src={
                  typeof previewUrl === 'string'
                    ? previewUrl
                    : '/Squircle22.png'
                }
                width={150}
                height={110}
                className="rounded-lg"
              />
              <label htmlFor="fileInput">
                <div className="rounded-[72px] bg-gray2 py-3 px-4 flex items-center gap-1 cursor-pointer">
                  <Icon
                    name="IconRefresh"
                    width={16}
                    height={16}
                    strokeWidth={1}
                    stroke={'#67A5B9'}
                  />
                  <p className={'text-text1 font-medium text-xs leading-5'}>
                    Change Logo
                  </p>
                  <input
                    id="fileInput"
                    type="file"
                    onChange={handleFileUpload}
                    style={{ display: 'none' }}
                    accept={'.pdf, .doc, .docx, .jpg, .jpeg, .png, .svg'}
                  />
                </div>
              </label>
              <div
                onClick={() => {
                  setPreviewUrl('')
                  setSelectedFile(null)
                }}
                className="bg-transparent border border-textError rounded-[72px] py-3 px-4 flex items-center gap-1 cursor-pointer"
              >
                <Icon
                  name="IconTrash"
                  width={16}
                  height={16}
                  strokeWidth={1}
                  stroke={'#FF6666'}
                />
                <p className="text-textError font-medium text-xs leading-5">
                  Delete
                </p>
              </div>
            </div>
          ) : (
            <div className="flex w-full items-center gap-4 mt-2">
              <div className="flex justify-center items-center bg-bluishGreen w-[150px] h-[110px] rounded-2xl">
                <Icon
                  name="IconBuilding"
                  width={24}
                  height={24}
                  strokeWidth={1.5}
                  stroke={'#FFFFFF'}
                />
              </div>
              <label htmlFor="fileInput">
                <div className="rounded-[72px] bg-gray2 py-3 px-4 flex items-center gap-1 cursor-pointer">
                  <Icon
                    name="IconPlus"
                    width={16}
                    height={16}
                    strokeWidth={1.2}
                    stroke={'#02698C'}
                  />
                  <p className={'text-text1 font-medium text-xs leading-5'}>
                    Add Profile Picture
                  </p>
                  <input
                    id="fileInput"
                    type="file"
                    onChange={handleFileUpload}
                    style={{ display: 'none' }}
                    accept={'.pdf, .doc, .docx, .jpg, .jpeg, .png, .svg'}
                  />
                </div>
              </label>
            </div>
          )}
          <div className="w-full">
            <p className="font-medium text-xs leading-5 text-text1">
              Your school logo should be XXX px XXX px and no bigger than Xmb
            </p>
          </div>
          <div className="w-full mt-[10px]">
            <UITextInput
              label={'School Name'}
              onChange={() => {}}
              onBlur={() => {}}
              placeholder="Your School Name"
              iconName={'none'}
              inputCustomClass="placeholder:font-normal"
            />
          </div>
          <div className="flex w-full">
            <div className="w-6/12 mr-3">
              <UITextInput
                label={'Address Line 1'}
                onChange={() => {}}
                onBlur={() => {}}
                placeholder="Address Line 1"
                iconName={'none'}
                inputCustomClass="placeholder:font-normal font-normal"
              />
            </div>
            <div className="w-6/12 ml-1">
              <UITextInput
                label={'Address Line 2'}
                onChange={() => {}}
                onBlur={() => {}}
                placeholder="(Optional)"
                iconName={'none'}
                inputCustomClass="placeholder:font-normal font-normal"
              />
            </div>
          </div>
          <div className="flex w-full">
            <div className="w-6/12 mr-3">
              <UITextInput
                label={'Town'}
                onChange={() => {}}
                onBlur={() => {}}
                placeholder="Town"
                iconName={'none'}
                inputCustomClass="placeholder:font-normal"
              />
            </div>
            <div className="w-6/12 ml-1">
              <UITextInput
                label={'Country'}
                onChange={() => {}}
                onBlur={() => {}}
                placeholder="Country"
                iconName={'none'}
                inputCustomClass="placeholder:font-normal"
              />
            </div>
          </div>
          <div className="w-full">
            <UITextInput
              label={'Postcode'}
              onChange={() => {}}
              onBlur={() => {}}
              placeholder="Postcode"
              iconName={'none'}
              inputCustomClass="placeholder:font-normal"
            />
          </div>
          <div className="w-full mt-4">
            <UIButton label={'Create'} onClick={() => {}} />
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default SuperSetting
